import { memo } from 'react';

import { BaseTableAssetTitle, type BaseTableAssetTitleProps } from './BaseTableAssetTitle';

export const PublicTableAssetTitle = memo((props: BaseTableAssetTitleProps) => <BaseTableAssetTitle {...props} />);

PublicTableAssetTitle.displayName = 'PublicTableAssetTitle';
